import { render, staticRenderFns } from "./DnsOptions.vue?vue&type=template&id=aa75719a&scoped=true"
import script from "./DnsOptions.vue?vue&type=script&lang=js"
export * from "./DnsOptions.vue?vue&type=script&lang=js"
import style0 from "./DnsOptions.vue?vue&type=style&index=0&id=aa75719a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa75719a",
  null
  
)

export default component.exports